import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { useGameStore } from '../../core/store';
import './pack-reveal.css';

/** Skill inventory tray — physical card lives in 3D; this is the HUD sink. */
export function PackReveal() {
  const core = useGameStore((s) => s.activeCore);
  const unlocked = useGameStore((s) => s.unlockedSkills);
  const tray = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!core || !tray.current) return;
    gsap.fromTo(
      tray.current,
      { y: 12, opacity: 0.4 },
      { y: 0, opacity: 1, duration: 0.35, ease: 'power2.out' },
    );
  }, [core, unlocked.length]);

  return (
    <div className="skill-inventory" ref={tray} aria-live="polite">
      <p className="skill-inventory__label">Skill Inventory</p>
      <div className="skill-inventory__row">
        {unlocked.map((id) => (
          <span
            key={id}
            className={`skill-inventory__chip${core?.id === id ? ' is-new' : ''}`}
          >
            {id}
          </span>
        ))}
        {unlocked.length === 0 && (
          <span className="skill-inventory__empty">Run into cores to unlock</span>
        )}
      </div>
      {core && (
        <p className="skill-inventory__toast">
          {core.title} · {core.move} → inventory
        </p>
      )}
    </div>
  );
}
